import { ValuationsApproach } from 'common/types/valuation';
import {
  FIVE_YEAR_VOLATILITY,
  MATURITY_VALUE_1_YEAR,
  MATURITY_VALUE_2_YEARS,
  MATURITY_VALUE_5_YEARS,
  ONE_YEAR_VOLATILITY,
  TWO_YEAR_VOLATILITY,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { getApproachTableName } from 'pages/ValuationsAllocation/util';

const getMExpression = (v1: string, v2: string, y1: number, y2: number) => `(${v2} - ${v1}) / (${y2} - ${y1})`;
const getVolatilityExpr = (
  v1: string,
  v2: string,
  y1: number,
  y2: number,
  maturityYearsCellKey: string,
) => {
  const m = getMExpression(v1, v2, y1, y2);
  return `=${m} * ${maturityYearsCellKey} + ${v2} - ${m} * ${y2}`;
};

const calculateVolatilityValue = (
  comparison: number,
  gpcApproach: ValuationsApproach,
  tableSuffix: string,
  maturityYearsCellKey: string,
) => {
  const tableName = getApproachTableName({
    approach: gpcApproach,
    tableSuffix,
  });

  let volatilityValue;
  switch (true) {
    case comparison <= MATURITY_VALUE_1_YEAR:
      volatilityValue = `=${tableName}.${ONE_YEAR_VOLATILITY}`;
      break;
    case comparison > MATURITY_VALUE_1_YEAR && comparison < MATURITY_VALUE_2_YEARS:
      volatilityValue = getVolatilityExpr(
        `${tableName}.${ONE_YEAR_VOLATILITY}`,
        `${tableName}.${TWO_YEAR_VOLATILITY}`,
        MATURITY_VALUE_1_YEAR,
        MATURITY_VALUE_2_YEARS,
        maturityYearsCellKey
      );
      break;
    case comparison > MATURITY_VALUE_2_YEARS && comparison < MATURITY_VALUE_5_YEARS:
      volatilityValue = getVolatilityExpr(
        `${tableName}.${TWO_YEAR_VOLATILITY}`,
        `${tableName}.${FIVE_YEAR_VOLATILITY}`,
        MATURITY_VALUE_2_YEARS,
        MATURITY_VALUE_5_YEARS,
        maturityYearsCellKey
      );
      break;
    case comparison === MATURITY_VALUE_2_YEARS:
      volatilityValue = `=${tableName}.${TWO_YEAR_VOLATILITY}`;
      break;
    default:
      volatilityValue = `=${tableName}.${FIVE_YEAR_VOLATILITY}`;
      break;
  }
  return volatilityValue;
};

export default calculateVolatilityValue;
